import { useContext, useEffect, useState } from 'react';
import { DashboardStateStore } from '../store/dashboardStore';
import { commodities } from '../../../constants/commodities';

const commoditiesOrder = [commodities.ELE.key, commodities.FIX.key, commodities.GAS_CZVTP.key, commodities.GAS_THE.key];
export const useCommoditiesStore = () => {
  const [commodities, setCommodities] = useState([]);
  const {
    state: {
      global: { data },
    },
  } = useContext(DashboardStateStore);

  useEffect(() => {
    if (data) {
      const commodities = Object.keys(data)
        .map((key) => {
          return {
            type: key,
            years: data[key],
          };
        })
        .sort((a, b) => {
          return commoditiesOrder.indexOf(a.type) > commoditiesOrder.indexOf(b.type) ? 1 : -1;
        });
      setCommodities(commodities);
    }
  }, [data]);

  return { commodities, setCommodities };
};
